// extracted by mini-css-extract-plugin
module.exports = {"tabGroup":"style_tabGroup__l6c2C","selected":"style_selected__EQPzy"};